import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd, Event as NavigationEvent } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OwlOptions } from "ngx-owl-carousel-o";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from "sweetalert2";
import { Title } from "@angular/platform-browser";
import { MemberNotificationService } from "src/app/shareModule/services/member-notification.service";
import { MarketplaceProfileComponent } from "src/app/customers/layout/component-layout/marketplace-profile/marketplace-profile.component";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { environment } from "src/environments/environment";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { SharedService } from "src/app/shareModule/services/shared.service";
import { CERTIFICATE_LIST } from "../community/roles/roles.model";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { AddProductComponent } from "../../admin/sub-admin/add-product/add-product.component";
import { CommonService } from "src/app/shareModule/services/common.service";
import { select, Store } from "@ngrx/store";
import { selectUser } from "src/app/shareModule/states/user-details";
import { BehaviorSubject, filter, Subscription, takeUntil } from "rxjs";
import { User } from "src/app/shareModule/models/user.model";
import { DOCUMENT, Location } from "@angular/common";
import { SeoService } from "src/app/shareModule/services/seo.service";
import { AppState } from "src/app/shareModule/states/app.state";
import { loadBizProducts, selectBizProducts } from "src/app/shareModule/states/biz-product";
import { BizProduct, BizProductResp } from "src/app/shareModule/models/biz-product.model";
import { loadBizCategory, selectAllBizCategory } from "src/app/shareModule/states/biz-category";
import { BizCategory } from "src/app/shareModule/models/biz-category";
import { loadBizBrand, selectAllBizBrand } from "src/app/shareModule/states/biz-brand";
import { ViewProductDetailsComponent } from "./view-product-details/view-product-details.component";

@Component({
  selector: "app-marketplace",
  templateUrl: "./marketplace.component.html",
  styleUrls: ["./marketplace.component.scss"],
})
export class MarketplacePageComponent implements OnInit, OnDestroy {
  @Input() share: boolean = false;

  @ViewChild("AddShop") addProductComponent: AddProductComponent;
  @ViewChild("viewProductModal") viewProductModal: ElementRef;
  // @ViewChild("ProductViewShell", { static: false }) productViewShell: ElementRef;
  @ViewChild("MarketplaceProfile")
  marketplaceProfileSection: MarketplaceProfileComponent;
  @ViewChild("MobileProfile") mobileProfileSection: MarketplaceProfileComponent;
  @ViewChild("specialCategoryModal", { static: true })
  specialCategoryModal: any;
  public currentUrl = this.location.path(); // Get the current URL path
  public defaultSellerMsg: string = "Information is not provided. Please do contact Seller via other methods.";
  private modalRef: any;
  carouselOptionsGallery: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };
  carouselOptionsLogos: any = {
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  };

  certificateList: any = CERTIFICATE_LIST;

  showMoreProduct: boolean = false;
  public categories: Array<BizCategory> = [];
  selectedCatId: any = "";
  subcategories: any = [];
  selectedsubCatId: any = "";
  food_listing_response: any;
  imgUrl = environment.ImageUrl;
  food_details: any = null;
  food_icon_1: any;
  food_icon_2: any;
  food_icon_3: any;
  food_icon_4: any;
  public editprodForm: FormGroup = this.fb.group({
    name: ["", [Validators.required]],
    descp: ["", [Validators.required]],
    memPrice: [""],
    nonMemPrice: ["", [Validators.required]],
    qty: ["", [Validators.required]],
    qtyName1: ["", [Validators.required]],
    qtyPrice1: ["", [Validators.required]],
    qtyName2: [""],
    qtyPrice2: [""],
    qtyName3: [""],
    qtyPrice3: [""],
    qtyName4: [""],
    qtyPrice4: [""],
    image1: [""],
    image2: [""],
    image3: [""],
    icon1: [""],
    icon2: [""],
    icon3: [""],
  });
  qty: any = "";
  submitted = false;
  get_selected_products_listing: any;
  selectedSubCatIndex: any = 0;
  filteredProducts: any = {};
  searchText: string = "";
  get_selected_products_listing_length: any;
  food_description: any;
  shop_signin_form: FormGroup;
  isLogin: any = 0;
  appUserId: any = 0;
  productForum: any = {};
  ckEditorText: string = "";
  selectedSpecialCategories: any = ["Popular Now"];
  showMessageBoxForum: boolean = true;
  shopForum: any = {
    list: [],
  };

  public brands: Array<any> = [];

  public enableMemberShop: Boolean = false;

  categoryIconMap = {
    POPULAR: "star",
    FOOD: "utensils",
    SERVICES: "concierge-bell",
    HEALTH: "heartbeat",
    BEAUTY: "spa",
    RETAIL: "shopping-cart",
    CAR: "car",
    FINANCE: "dollar-sign",
  };
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: true,
    navSpeed: 150,
    smartSpeed: 5500,
    slideTransition: "linear",
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 3,
      },
      740: {
        items: 4,
      },
      940: {
        items: 5,
      },
    },
    nav: true,
  };
  specialCategoryCustomOptions: OwlOptions = {
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    // dots: true,
    navSpeed: 700,
    smartSpeed: 4500,
    slideTransition: "linear",
    navText: ['<i class="fas fa-chevron-left special-cat-nav-icons"></i>', '<i class="fas fa-chevron-right special-cat-nav-icons"></i>'],
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 4,
      },
      740: {
        items: 5,
      },
      940: {
        items: 10,
      },
    },
    nav: true,
  };
  specialCategories: any = [
    {
      name: "Car",
      img: "../../../../assets/images/special_category/car.jpg",
    },
    {
      name: "Entertainment",
      img: "../../../../assets/images/special_category/entertainment.jpg",
    },
    {
      name: "Finance",
      img: "../../../../assets/images/special_category/finance.jpg",
    },
    {
      name: "Phone",
      img: "../../../../assets/images/special_category/phone.jpg",
    },
    {
      name: "Property",
      img: "../../../../assets/images/special_category/property.jpg",
    },
    {
      name: "Courier",
      img: "../../../../assets/images/special_category/courier.jpg",
    },
    {
      name: "Restaurant",
      img: "../../../../assets/images/special_category/Resturent.jpg",
    },
    {
      name: "Car Rental",
      img: "../../../../assets/images/special_category/car_rental.jpg",
    },
  ];
  specialCategoriesDelivery: any = [
    {
      name: "1 Day Delivery",
      img: "../../../../assets/images/special_category/1_Day_Delivery.jpg",
    },
    {
      name: "3 Hr Express",
      img: "../../../../assets/images/special_category/Icon_3.jpg",
    },
    {
      name: "International",
      img: "../../../../assets/images/special_category/international.jpg",
    },
  ];
  specialCategoriesPromotions: any = [
    {
      name: "Popular Now",
      img: "../../../../assets/images/special_category/Popular.jpg",
    },
    {
      name: "15% OFF",
      img: "../../../../assets/images/special_category/15_OFF.jpg",
    },
    {
      name: "30% OFF",
      img: "../../../../assets/images/special_category/30_OFF.jpg",
    },
    {
      name: "Limited Stock",
      img: "../../../../assets/images/special_category/LimitedStock.jpg",
    },
  ];

  public searchProduct: any = "";
  get editproduct() {
    return this.editprodForm.controls;
  }
  get shopSigninV() {
    return this.shop_signin_form.controls;
  }

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: "auto",
    pagination: false,
  };
  public bizIsLoading: boolean = false;
  public isLoadingMore: boolean = false;
  public page: any = 1;
  public categorySlug: any;
  public isBrowser = this.sharedService.isBrowser();
  public prePopupData = null;

  constructor(
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private memberNotificationService: MemberNotificationService,
    private title: Title,
    private sharedService: SharedService,
    public roleService: RoleService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private location: Location,
    private seoService: SeoService,
    @Inject("WINDOW") private window: any,
  ) {
    this.prePopupData = this.route.snapshot.data["MarketplaceResolver"]?.body || null;

    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        if (this.sharedService.isBrowser()) {
          requestAnimationFrame(() => {
            this.window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
          });
        }
      }
    });
    this.checkUrlAndOpenPopUp();
  }
  private destroy$ = new BehaviorSubject<void>(null);
  ngOnDestroy(): void {
    console.log('[Start Destroy] Marketplace')
    this.local.clearTimeout(this.timeout1)
    this.local.clearTimeout(this.timeout2)
    this.local.clearTimeout(this.timeout3)
    this._modalSubs?.unsubscribe();
    this.destroy$.next(null);
    this.destroy$.complete();
    console.log('[End Destroy] Marketplace')
  }
  private scrollPosition: [number, number] = [0, 0];

  ngOnInit(): void {
    this.sharedService.openProductDetail$.subscribe((params) => {
      this.enableMemberShop = params.enableMemberShop
      this.viewProduct({ id: params.id });
    })
    if (!this.share) {
      this.seoService.updateNoIndex(true)
      this.title.setTitle(`Kachiing Biz | KACHIING`);
      this.checkIfLogin();
      this.getCategoryList();
      this.isLoadingMore = true;
      this.getBizProducts();
      this.store.dispatch(loadBizCategory());
      this.store.dispatch(loadBizBrand());
      if (this.sharedService.isBrowser()) {
        this.getBrands();
        // setTimeout(() => {
        //   this.productViewShell ? (this.productViewShell.nativeElement.style.display = "none") : "";
        // });
      }
    }
  }

  timeout1: any;
  public checkUrlAndOpenPopUp() {
    this.preOpenPopup();


    this.route.queryParams.subscribe((param) => {
      const paramProduct = param['product']
      if (paramProduct) {
        this.enableMemberShop = !this.currentUrl.includes("/biz") || !paramProduct.includes('-biz-');
        this.local.clearTimeout(this.timeout1)
        this.timeout1 = setTimeout(() => {
          this.viewProduct({ id: paramProduct });
        });
      } else {
        this.modalRef ? this.modalRef.close() : "";
      }
    })

  }

  public preOpenPopup() {
    // if (this.sharedService.isBrowser()) {
    //   this.modalRef = this.modalService.open(this.viewProductModal, {
    //     //Pop-up
    //     size: "sm",
    //     ariaLabelledBy: "modal-basic-title",
    //     windowClass: "product_detail_popup",
    //   });
    // }
    this.skipPopupOpen = false;
  }

  // ***** Biz Product List selector *****
  public getBizProducts(): void {
    this.store.pipe(select(selectBizProducts)).subscribe((response: BizProductResp) => {
      if (response.data && response.data.length >= 0) {
        this.bizIsLoading = false;
        if (this.page == 1) {
          this.filteredProducts = JSON.parse(JSON.stringify(response));
        } else {
          let newProducts = JSON.parse(JSON.stringify(response));
          let list1 = newProducts.data || [];
          let list2 = this.filteredProducts.data || [];

          this.filteredProducts = {
            ...newProducts,
            data: [...list2, ...list1],
          };
          this.isLoadingMore = false;
          this.isLoadingMore = false;
        }
      }
      this.isLoadingMore = false;
    });
  }

  public getCategoryList(): void {
    this.store.pipe(select(selectAllBizCategory)).subscribe((response: any) => {
      this.categories = structuredClone(response || []);
      this.categories.map((c) => {
        c["slug"] = c.name.toLowerCase().replace(/ /g, "-");
      });
      this.selectedCatId = "";
      this.getAllSubCategories();
      this.route.params.subscribe((param) => {
        const categorySlug = param["category"];
        if (categorySlug) {
          const category = this.categories.filter((c) => c.slug === categorySlug)[0];

          if (category) {
            this.tabChange(category);
          }
        } else {
          this.applySpecialCategoryFilter("Popular Now", true);
        }
      });
    });
  }

  public getBrands() {
    this.store.pipe(select(selectAllBizBrand)).subscribe((response: any) => {
      this.brands = response;
    });
  }

  onNavigate(url, cate = "", subCate = "") {
    this.scrollPosition = [this.window.scrollX, this.window.scrollY];
    var query: any = {};
    if (cate) {
      query.category = cate;
    }
    if (subCate) {
      query["sub-category"] = subCate;
    }
    this.router.navigate([url], {
      queryParams: query,
    });
  }

  checkIfLogin() {
    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((response: User) => {
        if (response?.id) {
          this.appUserId = response.id;
          this.isLogin = 1;
        } else {
          this.isLogin = 0;
        }
      });
  }

  handleSearchProduct() {
    this.getAllSubCategories();
    this.getProductList(this.selectedsubCatId)
  }

  handleHideProduct() {
    this.checkIfLogin();
    if (this.food_details.hiddenBy.includes(this.appUserId)) {
      this.toastr.error("maximum 1 time for request");
      return;
    }
    this.local
      .alertConfirm({
        message: `Are you sure want to hide this product ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth.hideMemberShopProduct({ productId: this.food_details.id }).subscribe(
            (resp: any) => {
              Swal.close();
              this.toastr.success(resp.message);
              this.food_details.hiddenBy.push(this.appUserId);
            },
            () => {
              Swal.close();
              // this.toastr.error(e.error.message)
            }
          );
        }
      });
  }

  dismissedDetail: boolean = false;
  isLoading: boolean = false;
  viewed: boolean = false;

  public static globalModalRef: NgbModalRef | null = null;
  timeout2: any;
  public viewProduct(selectedProduct: any, isSearch = false, dissmissAll: boolean = true): void {
    this.viewed = true

    // // Fetch attached product data if it exists
    if (selectedProduct && selectedProduct?.attachmentProducts) {
      this.getAttachedProductData(selectedProduct?.attachmentProducts);
    }

    // Handle modal state
    if (!isSearch && !this.skipPopupOpen && dissmissAll) {
      this.modalService.dismissAll();
    }

    // Reset skip state if necessary
    if (this.skipPopupOpen && !selectedProduct.skip) {
      this.prevProduct = null;
      this.skipPopupOpen = false;
    }

    // Open modal only if skipPopupOpen is false
    if (!this.skipPopupOpen) {
      if (this.sharedService.isBrowser()) {
        this.modalRef = this.modalService.open(this.viewProductModal, {
          size: "sm",
          ariaLabelledBy: "modal-basic-title",
          windowClass: "product_detail_popup",
        });

      }

      MarketplacePageComponent.globalModalRef = this.modalRef;
    }

    this.modalRef
      ? this.modalRef.closed.subscribe(() => {
        this.skipPopupOpen = false;
        this.prevProduct = null;
        this.food_details = null;
        this.location.replaceState(`${this.currentUrl.split("?")[0]}`);
        this.viewed = false
        this.seoService.removeSchema()
      })
      : "";

    // // Ensure user is logged in
    this.checkIfLogin();

    // Preload data for faster UI updates if necessary
    if (this.enableMemberShop && selectedProduct.name) {//selectedProduct.primaryImage) {
      try {
        if (!selectedProduct.seller) {
          selectedProduct.seller = selectedProduct.appUser
        }
        if (typeof selectedProduct?.appUser?.certified === 'string') {
          selectedProduct.appUser.certified = JSON.parse(selectedProduct.appUser.certified)
          //console.log("Got certified data", selectedProduct.appUser.certified )
        }
      } catch (e) {
      }

      this._setViewProductModalData(selectedProduct, selectedProduct);
      this.isLoading = false;
      this.local.clearTimeout(this.timeout2)
      this.timeout2 = setTimeout(() => {
        document.querySelector(".modal.product_detail_popup ")?.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      return;
    }

    // Prepare formData and make the API call
    const formData = new FormData();
    formData.append("foodId", selectedProduct?.id);

    if (this.enableMemberShop) {
      this.auth.getShopProductDetails({ productId: selectedProduct?.id })
        // .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          !this.sliderData[selectedProduct?.id] ? (this.sliderData[selectedProduct?.id] = this.food_details) : "";
          this._setViewProductModalData(selectedProduct, response.body);
          this.isLoading = false

          // Scroll modal to the top after content has been loaded
          if (!this.skipPopupOpen) {
            this.local.clearTimeout(this.timeout2)
            this.timeout2 = setTimeout(() => {
              document.querySelector(".modal.product_detail_popup ")?.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
          }
        });
    } else {
      this.food_details = null;
      this.auth.get_food_details(formData)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          this._setViewProductModalData(selectedProduct, response.body);
          this.isLoading = false

          // Scroll modal to the top after content has been loaded
          if (!this.skipPopupOpen) {
            document.querySelector(".modal.product_detail_popup ")?.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
    }
  }

  private _modalSubs?: Subscription | null = null;

  timeout3: any;
  private _setViewProductModalData(selectedProduct, response) {
    this.food_details = structuredClone(response);

    this.food_details.shoutContact = this.food_details.shoutContact?.toString().substr(0, 2) == "65" ? this.food_details.shoutContact : `65${this.food_details.shoutContact}`

    if (this.food_details && this.food_details?.name) {
      if (this.food_details?.type == "rental" && !this.food_details.name.includes('- RENTAL')) {
        this.food_details.name += ' - RENTAL'
      }
      let foodName = this.food_details?.name;
      if (this.food_details?.seller?.shop_name && this.food_details?.seller?.shop_name != 'null') {
        foodName += " | " + this.food_details?.seller?.shop_name;
      }

      const companyName = this.food_details?.companyName ? ` By ${this.food_details?.companyName}` : ''

      this.seoService.update({
        main_title: ' | BEST SERVICES SG',
        title: foodName + companyName,
        description: this.food_details?.description || 'No description available',
        image: this.imgUrl + (this.food_details?.primaryImage || 'default-image.png'),
      });
      // this.seoService.addMetaTags(this.food_details?.metadata)

      // this.seoService.removeSchema()
      // this.seoService.initSchema(this.food_details)

      // if (this.food_details?.type != 'promote' && this.enableMemberShop) {
      //   if (!this.food_details?.appUser?.noIndexProduct || this.food_details.noIndex) {
      //     this.seoService.updateNoIndex(true);
      //   }
      // }

      // if (!this.enableMemberShop && !this.food_details.isHighlight) {
      //   this.seoService.updateNoIndex(true);
      // }
    }
    this.seoService.updateNoIndex(true);
    this.food_details["edit_product_id"] = selectedProduct?.id;
    this.food_details["enableMemberShop"] = this.enableMemberShop;
    this.food_details["prevProduct"] = this.prevProduct;

    if (!this.skipPopupOpen) {
      if (!this.food_details.slug)
        this.food_details.slug = `${(this.food_details?.name).replace(' - RENTAL', '').trim().toLowerCase().replace("🥢", "").replace('-⁣⁣-', '-').replace(/\s+/g, "-")}${(this.enableMemberShop || this.food_details.enableMemberShop) ? '' : '-biz'}-${this.food_details?.id}`
      const queryParams = this.local.buildQuery({
        product: this.food_details?.slug
      })
      this.location.replaceState(`${this.currentUrl.split("?")[0]}?${queryParams}`); // ******=> Set Dynamic Location

      if (this.modalRef) {
        this._modalSubs?.unsubscribe();
        this._modalSubs = this.modalRef.dismissed.subscribe(() => {
          let urlProductId: any = this.window.location.href.split("-");
          urlProductId = urlProductId[urlProductId.length - 1];

          // alert(this.currentUrl)
          if (urlProductId == selectedProduct?.id || urlProductId == this.food_details?.id) {
            this.location.replaceState(`${this.currentUrl.split("?")[0]}`);
          } else {
            this.location.replaceState(`${this.currentUrl.split("?")[0]}`);
          }
          this.viewed = false
          this.seoService.removeSchema()
        })

      } else {

      }
    }
    try {
      this.food_details["selectedHolidays"] = this.food_details.holidays ? JSON.parse(this.food_details.holidays) : "";
      this.food_details.hiddenBy = this.food_details.hiddenBy != null ? JSON.parse(this.food_details.hiddenBy) : [];
    } catch (e) { }

    if (response?.body?.sellerInfo || response?.sellerInfo) {
      try {
        this.food_details["sellerInformation"] = JSON.parse(response?.body?.sellerInfo || response?.sellerInfo);
      } catch {
        this.food_details["sellerInformation"] = {};
      }
    }

    if (this.food_details.icons != null && this.food_details.icons != "") {
      const icons = JSON.parse(this.food_details.icons);
      this.food_details["iconsWithText"] = icons.filter((item: any) => item.text !== "");
      this.food_details["iconsWithoutText"] = icons.filter((item: any) => item.text === "");
    }

    this.foodFavoriteStatus(this.food_details.id); //check
    const getImageByAccessor = (images, accessor) => {
      const imageObj = images?.find((o) => o.imageAccessor === accessor);
      return imageObj ? imageObj.image : "";
    };
    if (this.enableMemberShop) {
      this.food_details["foodSpecs"] = this.food_details?.memberShopProductsVariations || [];
      this.food_details["food_image_1"] = getImageByAccessor(this.food_details.memberShopProductsImages, "image1");
      this.food_details["food_image_active"] = this.food_details["food_image_1"];
      this.food_details["food_image_2"] = getImageByAccessor(this.food_details.memberShopProductsImages, "image2");
      this.food_details["food_image_3"] = getImageByAccessor(this.food_details.memberShopProductsImages, "image3");
      this.food_details["food_image_4"] = getImageByAccessor(this.food_details.memberShopProductsImages, "image4");

      this.food_icon_1 = getImageByAccessor(this.food_details.memberShopProductsImages, "icon1");
      this.food_icon_2 = getImageByAccessor(this.food_details.memberShopProductsImages, "icon2");
      this.food_icon_3 = getImageByAccessor(this.food_details.memberShopProductsImages, "icon3");
      this.food_icon_4 = getImageByAccessor(this.food_details.memberShopProductsImages, "icon4");
    } else {
      this.food_details["food_image_1"] = getImageByAccessor(this.food_details.foodImages, "image1");
      this.food_details["food_image_active"] = this.food_details["food_image_1"];
      this.food_details["food_image_2"] = getImageByAccessor(this.food_details.foodImages, "image2");
      this.food_details["food_image_3"] = getImageByAccessor(this.food_details.foodImages, "image3");
      this.food_details["food_image_4"] = getImageByAccessor(this.food_details.foodImages, "image4");

      this.food_icon_1 = getImageByAccessor(this.food_details.foodImages, "icon1");
      this.food_icon_2 = getImageByAccessor(this.food_details.foodImages, "icon2");
      this.food_icon_3 = getImageByAccessor(this.food_details.foodImages, "icon3");
      this.food_icon_4 = getImageByAccessor(this.food_details.foodImages, "icon4");
    }
    this.food_description = this.food_details.description;

    //my tabs
    this.food_details["tabsInfo"] = [
      // {
      //   title: "Price",
      //   icon: "fa-solid fa-dollar-sign",
      //   condition: ((this.food_details?.memberShopProductsVariations?.length > 0 && this.food_details?.type != 'promote')
      //     || this.food_details?.["foodSpecs"]?.length > 0 && this.food_details?.["foodSpecs"].some(x => x.key != '$0' && x.key != '0')) //&& this.food_details.type != "promote",
      // },
      {
        title: "Info",
        icon: "fa-solid fa-circle-info",
        condition:  (this.isLogin || this.food_details?.hasReview)|| (this.food_details.description != "" || ((this.food_details?.memberShopProductsVariations?.length > 0 && this.food_details?.type != 'promote')
          || this.food_details?.["foodSpecs"]?.length > 0 && this.food_details?.["foodSpecs"].some(x => x.key != '$0' && x.key != '0')))
      },
      {
        title: "Detail",
        // icon: 'fa-solid fa-circle-info',
        condition: this.food_details.charges != "" && this.food_details.charges != undefined && this.food_details.charges != "null" && this.food_details.charges != "-",
      },

      {
        title: "Rent",
        // icon: 'fa-solid fa-circle-info',
        condition: this.food_details?.type == "rental" && (this.food_details?.depositAmt || this.food_details?.estimateValue || this.food_details?.warranty),
      },
      {
        title: "Contact",
        icon: "fa-solid fa fa-phone",
        condition: this.food_details?.type == "promote" && (this.food_details?.roleName?.includes("SUPER SELLER") || this.food_details?.roleName?.includes("ADMIN")) && (this.nullCheck(this.food_details?.shoutContactRelation) || this.nullCheck(this.food_details?.shoutWebsite)),
      },
      {
        title: this.food_details?.subRegionName?.trim() ?? "Location",
        icon: "fa-solid fa-location",
        condition: (this.food_details?.type == "promote" && this.food_details?.latLong != '{}' && this.food_details?.latLong != null)
          || (this.food_details?.type != 'promote' && this.food_details?.appUser?.postalCode != null)
      }
    ];

    this.food_details["tabs"] = [
      {
        title: "USP",
        condition: this.food_details?.productVerficationsList?.length > 0
      },
      {
        title: "More",
        condition: this.food_details?.productMoreServices?.length > 0
      },
      {
        title: "Profile",
        //  icon: 'fa-solid fa-user'
      },
      {
        title: "More Products",
        // icon: '',
        condition: this.food_details?.more_products_data?.length > 0,
      },
      {
        title: "Socials",
        // icon: 'fa-solid fa-star',
        condition:
          this.food_details["sellerInformation"]?.fbReviewUrl ||
          this.food_details["sellerInformation"]?.carousellReviewUrl ||
          this.food_details["sellerInformation"]?.googleReviewUrl ||
          this.food_details["sellerInformation"]?.websiteUrl ||
          this.food_details["sellerInformation"]?.instagramUrl ||
          this.food_details["sellerInformation"]?.fbUrl,
      },

      // {
      //   title: 'Holiday',
      //   condition:
      //     this.food_details?.selectedHolidays.length > 0 &&
      //     (this.food_details?.roleName?.includes('SUPER SELLER') ||
      //       this.food_details?.roleName?.includes('ADMIN')),
      // },
    ];


    this.local.clearTimeout(this.timeout3)
    this.timeout3 = setTimeout(() => {
      const modalContent = document.getElementsByClassName("modal-body");
      if (modalContent.length > 0) {
        modalContent[0].scrollTop = 0; // Scroll to the top of the first element with the class 'modal-body'
      }
    }, 100);
  }


  foodFavoriteStatus(foodId: any) {
    let formData = null;
    if (this.enableMemberShop) {
      formData = {
        member_product_id: foodId,
        isAdmin: this.isAdmin(),
      };
    } else {
      formData = {
        foodId: foodId,
        isAdmin: this.isAdmin(),
      };
    }
    this.auth.marketplace_favorite_product_status(formData).subscribe((response: any) => {
      this.food_details.isFavorite = response.body.status;
    });
  }

  toastWarning() {
    this.toastr.warning("enter store to see product");
  }
  handleInfoAP() {
    this.local.alertInfo({
      title: `<p style="color: var(--primary)">AP (Ambassador Program)</p>`,
      message: `
        <p style="color: var(--primary)">Business is running a loyalty program to reward referrals and believers in their product & services. This payment is only redeemable via PAYNOW. Please contact support if you have any questions. Participation is not mandatory. T&C applies.</p>
      `,
    });
  }
  getProductsForSlider() {
    this.auth.marketplace_featured_products()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.get_selected_products_listing = response;
          this.get_selected_products_listing_length = response.length;
        },
        (e) => {
          if (e.status == 400) {
            //this.toastr.error(e.error.message);
          }
        }
      );
  }
  getNameCate(id) {
    if (id) {
      return this.categories.filter((c) => c.id === id)[0].name;
    }
  }

  getAllSubCategories() {
    const formData = new FormData();

    formData.append("categoryId", this.selectedCatId);

    this.auth.marketplace_subcategories(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.subcategories = response.body || [];

          this.selectedSubCatIndex = 0;

          this.subcategories.unshift({
            id: "",
            name: "PRODUCTS",
          });

          // this.route.queryParamMap.subscribe((params) => {
          //   const subCategoryName = params.get("sub-category");
          //   this.subCatTabChange(this.subcategories.filter((c) => c.name === subCategoryName)[0]);
          // });

          this.subCatTabChange(this.subcategories[0]);
          this.getProductList(this.selectedsubCatId);
        },
        (e) => {
          if (e.status == 400) {
            //this.toastr.error(e.error.message);
          }
        }
      );
  }

  getProductList(subCatId, page = 1) {
    this.page = page;
    if (this.page == 1) {
      this.bizIsLoading = true;
    } else {
      this.isLoadingMore = true;
    }

    this.store.dispatch(
      loadBizProducts({
        categoryId: this.selectedCatId,
        subCategoryId: subCatId,
        specialCategory: JSON.stringify(this.selectedSpecialCategories),
        search: this.searchProduct,
        page: this.page,
        limit: 15,
      })
    );
  }

  tabChange(item) {
    this.seoService.update({
      title: item?.name,
      description: item?.name,
    });
    this.selectedSpecialCategories = [];
    this.searchText = "";
    this.selectedCatId = item?.id || "";
    this.location.replaceState(`biz/category/${item?.slug}`);
    this.currentUrl = `/biz/category/${item?.slug}`;
    this.getAllSubCategories();
  }
  subCatTabChange(item) {
    this.searchText = "";
    this.selectedsubCatId = item?.id || "";
  }

  handleTabDescription(e: any, value: string) {
    e.preventDefault();
    this.food_details.isTabActive = value;
    document.getElementById("descriptionText").innerHTML = this.food_details[value]?.replaceAll(/\n/g, "<br>").replaceAll("<b>", `<b style="font-weight: 700">`);
  }

  getPages(): number[] {
    const pages = [];
    const currentPage = this.shopForum.currentPage;
    const lastPage = this.shopForum.lastPage;

    // Determine the range of pages to display
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(lastPage, currentPage + 2);

    // Adjust startPage and endPage if they are at the extremes
    if (currentPage <= 3) {
      endPage = Math.min(lastPage, 5);
    } else if (currentPage >= lastPage - 2) {
      startPage = Math.max(1, lastPage - 4);
    }

    // Generate the page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
  getShopForum(adminId: any, page: number = 1, repeat: boolean = false) {
    if (page == this.shopForum.currentPage && !repeat) return;

    this.auth.marketplace_forum_shop_fetch(adminId, page)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        const result = response.body;
        this.shopForum.list = result.data;
        this.shopForum.currentPage = result.currentPage;
        this.shopForum.lastPage = result.lastPage;
        this.shopForum.list.map((row: any) => {
          row.user = row.user ?? {};
          row.replyText = "";
          row.createdAt = new Date(row.createdAt * 1000).toLocaleString();
          row.showReply = false;
        });
      });
  }
  getShopForumReply(index: number) {
    const forum = this.shopForum.list[index];
    const showReply = (this.shopForum.list[index].showReply = !forum.showReply);

    if (showReply)
      this.auth.marketplace_forum_shop_fetch_reply(forum.id).subscribe((response: any) => {
        this.shopForum.list[index].replies = response.body;
        this.shopForum.list[index].replies.map((row: any) => {
          row.user = row.user ?? {};
          row.createdAt = new Date(row.createdAt * 1000).toLocaleString();
        });
      });
  }
  forumProductModal(modal: any, product: any): void {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "forum_product_modal",
    });

    this.productForum = product;

    this.shopForum = {
      list: [],
    };

    this.auth.marketplace_forum_shop(product.adminId).subscribe((response: any) => {
      const shop = response.body;
      this.shopForum = shop;
      this.getShopForum(product.adminId);
    });
  }
  async handleShowOptionForum(index: number) {
    await Promise.all(
      this.shopForum?.list.map((row: any, i: number) => {
        if (index != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.shopForum.list[index].showOption = !this.shopForum.list[index].showOption;
    });
  }
  async handleShowOptionForumReply(index: number, indexReply: number) {
    await Promise.all(
      this.shopForum?.list[index].replies.map((row: any, i: number) => {
        if (indexReply != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.shopForum.list[index].replies[indexReply].showOption = !this.shopForum.list[index].replies[indexReply].showOption;
    });
  }
  isAdmin = () => this.local.getUser()?.role == "admin";
  isModerator = () => this.local.getUser()?.role == "moderator";
  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;

    if (this.isAdmin()) {
      return user.id == data.createdBy && data.isAdmin;
    } else {
      return user.id == data.createdBy && !data.isAdmin;
    }
  };
  storeForumMessage(id: number = null) {
    if (this.ckEditorText.length < 1 && id == null) {
      return this.toastr.error("Please Fill a Message");
    }
    this.productForum.hasSubmit = true;

    const form = {
      shopId: this.productForum.adminId,
      message: this.ckEditorText,
      createdBy: this.appUserId,
      id: id,
      isAdmin: this.isAdmin(),
    };

    try {
      this.auth.marketplace_forum_shop_store(form).subscribe(() => {
        this.productForum.hasSubmit = false;
        Swal.fire({
          title: "Success",
          text: "The message was successfully added",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "var(--primary)",
          confirmButtonText: "OK",
        }).then(() => {
          this.getShopForum(this.productForum.adminId, 1, true);
        });
        this.ckEditorText = "";
      });
    } catch (e) {
      this.productForum.hasSubmit = false;
    }
  }
  storeForumMessageEdit(id: number) {
    this.storeForumMessage(id);
  }
  editForumMessage(event: any, index: number) {
    event.preventDefault();
    this.shopForum.list[index].isEdit = !this.shopForum.list[index].isEdit;
    this.shopForum.list[index].messageEdit = this.shopForum.list[index].message;
    this.shopForum.list[index].showOption = false;
  }
  editForumMessageReply(event: any, index: number, indexReply: number) {
    event.preventDefault();
    this.shopForum.list[index].replies[indexReply].isEdit = !this.shopForum.list[index].replies[indexReply].isEdit;
    this.shopForum.list[index].replies[indexReply].messageEdit = this.shopForum.list[index].replies[indexReply].message;
    this.shopForum.list[index].replies[indexReply].showOption = false;
  }
  showReplyMessageBox(event: any, index: number) {
    event.preventDefault();
    this.shopForum.list[index].showReplyBox = !this.shopForum.list[index].showReplyBox;
  }
  storeForumMessageReply(index: number, id: number = null) {
    const forum = this.shopForum.list[index];
    if (forum.replyText.length < 1 && id == null) {
      return this.toastr.error("Please Fill a Message");
    }

    this.productForum.hasSubmit = true;

    const form = {
      forumId: forum.id,
      message: forum.replyText,
      createdBy: this.appUserId,
      id: id,
      isAdmin: this.isAdmin(),
    };

    try {
      this.auth.marketplace_forum_shop_store_reply(form).subscribe(() => {
        this.productForum.hasSubmit = false;
        Swal.fire({
          title: "Success",
          text: "The message was successfully added",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "var(--primary)",
          confirmButtonText: "OK",
        }).then(() => {
          this.getShopForumReply(index);
          this.shopForum.list[index].repliesCount += 1;
          this.shopForum.list[index].showReplyBox = false;
          this.shopForum.list[index].showOption = false;
        });
        forum.replyText = "";
      });
    } catch (e) {
      this.productForum.hasSubmit = false;
    }
  }
  deleteForumMessage(event: any, id: any) {
    event.preventDefault();
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        try {
          this.auth.marketplace_forum_shop_delete(id).subscribe(() => {
            this.local.alertSuccess({}).then(() => {
              this.getShopForum(this.productForum.adminId, 1, true);
            });
          });
        } catch (e) {
          this.local.alertInternalError();
        }
      }
    });
  }
  deleteForumMessageReply(event: any, id: any, index: number) {
    event.preventDefault();
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        try {
          this.auth.marketplace_forum_shop_delete_reply(id).subscribe(() => {
            this.local.alertSuccess({}).then(() => {
              this.shopForum.list[index].repliesCount -= 1;
              this.shopForum.list[index].showReply = false;
            });
          });
        } catch (e) {
          this.local.alertInternalError();
        }
      }
    });
  }

  onEditorChange(event) {
    this.ckEditorText = event.editor.getData();
  }
  modalDismissAll() {
    this.modalService.dismissAll();
  }
  search() {
    this.filteredProducts =
      this.searchText === ""
        ? this.food_listing_response
        : this.food_listing_response.filter((element) => {
          return element.name.toLowerCase().includes(this.searchText.toLowerCase());
        });
  }

  applySpecialCategoryFilter(category, isOnce = false) {
    this.checkIfLogin();
    this.selectedCatId = "";
    if (!isOnce)
      if (this.selectedSpecialCategories.includes(category)) {
        this.selectedSpecialCategories.splice(this.selectedSpecialCategories.indexOf(category), 1);
      } else {
        this.subcategories = [
          {
            id: "",
            name: "PRODUCTS",
          },
        ];
        this.selectedSpecialCategories.push(category);
      }
    else {
      this.subcategories = [
        {
          id: "",
          name: "PRODUCTS",
        },
      ];
      this.selectedSpecialCategories = [category];
    }
    this.getProductList(this.selectedsubCatId);
  }

  openSpecialCategory(modal) {
    this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "special_category_modal",
    });
  }

  openShopSigninPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "shop_signin_pop",
    });

    this.shop_signin_form = this.fb.group({
      phone_number: ["", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(8)]],
    });
  }
  shop_sign_in() {
    this.local.removeData();
    const data = this.local.getUser();
    if (data) {
      this.local.removeAdminData();
    }

    this.submitted = true;
    if (this.shop_signin_form.invalid) {
      return;
    }

    const formData = new FormData();
    formData.append("phoneNumber", this.shopSigninV.phone_number.value);

    this.auth.login_signup_new_customer_marketplace(formData).subscribe(
      (response: any) => {
        this.isLogin = 1;
        this.toastr.success(response.message);
        this.local.saveLoginUserData(response.body);
        this.ngOnInit();
        this.router.navigate(["/biz"]);
        this.submitted = false;
        this.shop_signin_form.reset();
        this.modalService.dismissAll();
        this.memberNotificationService.getNotification();
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }
      }
    );
  }
  numpad(value: any) {
    const control = this.shop_signin_form.get("phone_number");
    if (value == "Del") control.setValue((control.value || "").slice(0, -1));
    else control.setValue((control.value || "") + value);
  }

  shopLogout() {
    this.isLogin = 0;
    this.local.removeData();
    this.local.removeAdminData();
    this.modalDismissAll();
    // ** sign-out member **
    this.auth.logout_customer_marketplace({ id: this.appUserId }).subscribe((response: any) => {
      this.toastr.success(response.message);
      this.memberNotificationService.clearNotification();
    });
  }

  public editMemberProduct(product) {
    this.addProductComponent.memberShopProductType = product?.type;
    this.addProductComponent.selectedCatId = product?.categoryId;
    this.addProductComponent.selectedCategoryNameForDD = product?.categoryName;

    this.addProductComponent.selectedSubRegionId = product?.subRegionId;
    this.addProductComponent.editProductModal(product.id);
  }

  public deleteMemberProduct(productId) {
    this.addProductComponent.delete_food(productId);
  }

  public prevProduct: any = null;
  public skipPopupOpen: boolean = false;

  public sliderData: any = {};

  public nextProduct(event: any) {
    // Pre Fetch data
    if (!this.sliderData[this.food_details["id"]]) {
      this.sliderData[this.food_details["id"]] = this.food_details;
    }
    // Pre Fetch data

    let id;
    if (event.activeIndex == 1) {
      id = this.food_details?.["attachmentProducts"];
    } else {
      id = this.prevProduct;
    }

    this.prevProduct = this.prevProduct ? this.prevProduct : this.food_details["id"];

    if (id && this.food_details["id"] != id) {
      this.skipPopupOpen = true;

      let prefetchData = { id: id, skip: true };
      if (this.sliderData[id]) {
        prefetchData = { ...this.sliderData[id], skip: true };
      }
      this.viewProduct(prefetchData, false);
    }
  }

  public viewProductEvent(action) {
    if (action == "getProductList") {
      this.getProductList(this.selectedsubCatId);
    }
  }

  public selectedBrand: any = null;
  public openPopup(brand, modal) {
    this.selectedBrand = brand;
    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "suggestion",
    });
  }

  public goToBrand(url: string): void {
    if (!/^(https?:\/\/)/i.test(url)) {
      // If not, prepend 'https://'
      url = "https://" + url;
    }

    this.window.open(url, "_blank");
  }

  public getAttachedProductData(id) {
    if (!this.sliderData[id]) {
      this.isLoading = true;
      this.auth.getShopProductDetails({ productId: id }).subscribe((resp: ApiResponse) => {
        this.sliderData[resp.body["id"]] = resp.body;
      });
    }
  }

  private nullCheck(value: any): string {
    if (value === null || value === 'null' || value === '') {
      return '';
    }
    return value;
  }
}
